require('./cardChangeNewPaymentMethodStep3.scss');

import React, { useEffect, useState } from 'react';
import { i18n } from 'core/i18n';
import { SignaturePattern } from 'components/signaturePattern/signaturePattern';
import { CARD_PAYMENT_CHANGE_ID } from 'constants/operationTypes';
import { CARD_PAYMENT_METHOD_UNIQUE, CARD_PAYMENT_METHOD_FIXED, CARD_PAYMENT_METHOD_VARIABLE, SECOND_STEP } from 'constants/index';
import { HireNewCreditCardPdf } from 'components/hire/newCreditCard/hireNewCreditCardPdf/hireNewCreditCardPdf';
import { OKConsents } from 'gdpr-consents/components/OKConsents/OKConsents.js';
import { GDPRSignaturePattern } from 'components/gdprSignaturePattern/gdprSignaturePattern';
import BlockInfo from 'components/contactCenter/blockInfo/blockInfo';
import { isPrintOfficeMode } from 'utilities/contactCenter/printerHelper';
import ContactCenterRender from 'components/conditionalRender/contactCenterRender';
import ContactCenterNewValidationCards from 'components/hire/contactCenterValidationCards/contactCenterNewValidationCards';
import { NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES } from 'constants/flagBasedFeatures';

export const CardChangeNewPaymentMethodStep3 = ({
    immCard,
    immCardChangePaymentMethod,
    showIneAndRevolving,
    placementIdCard,
    immPdfRevolvingPersistent,
    immHirePaymentMethod,
    immHireCardNameSelector,
    immHireCreditLimit,
    immShippingAddressList,
    currentMethod,
    operationParams,
    immFlagBasedFeatures,
    handleAgreementCheckboxChange,
    onHandleChangeCheckBoxCC,
    processEmail
}) => {
    const { FormattedText, formatText } = i18n;

    const methodSelected = immCardChangePaymentMethod.get('steps').get(0).get('method');
    const titleKey = `cardChangePaymentMethod-${showIneAndRevolving ? 'revolvingTitleStep2' : 'securityConfirmation'}`;
    const isForRevolvingProcess = immCard.get('isForRevolvingProcess');
    const operationProcessId = immCardChangePaymentMethod.get('operationProcessIdInitPolicy')
    const agreeIneCheckbox = immCardChangePaymentMethod.get('agreeIneCheckbox')
    const [printOffice, setPrintOffice] = useState(false)

    useEffect(() => {
        if (immCardChangePaymentMethod.get('steps').get(1).get('agreementChecked')) {
            setSignatureSectionRevolving(buildSignatureSection());
        }
    }, [immCardChangePaymentMethod]);
    const buildSignatureSection = () => {
        return (
            <section className="card-change-payment-method-step-two__content">
                <SignaturePattern
                    operationType={CARD_PAYMENT_CHANGE_ID}
                    operationParams={{}}
                />
            </section>
        );
    };
    const onHandleChangeCheckBox = (evt) => {
        return handleAgreementCheckboxChange(evt, SECOND_STEP)
    }
    const buildLegalConfirmationSection = () => {
        const productType = immHireCreditLimit.get('productType');
        const productSubType = immHireCreditLimit.get('productSubType');
        const standard = immHireCreditLimit.get('referenceStandard');
        const amount = immCard.getIn(['limit', 'amount'])

        const precontractualMailProductInfo = {
            productName: 'Vanity Fair Card',
            producto: productType,
            standard: standard,
            subproducto: productSubType,
        }

        const newCardsFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES);
        const immStep = immCardChangePaymentMethod.getIn(['steps', SECOND_STEP]);
        const agreementLabel = <FormattedText value={'hireCardNeruda-hireCardNeruda_step4NewCheckboxText'} />;
        const agreementErrorMsg = formatText('hireCardNeruda-hireCardNeruda_step4CheckboxErrorMsg');
        const documentINE = immCardChangePaymentMethod.get('documentINE')
        const documentPolicy = immCardChangePaymentMethod.get('documentPolicy')
        const newIntLoading = documentINE && documentPolicy
        const sendMailParams = {
            type: productType,
            subType: productSubType,
            standar: standard,
        };
        return (
            <ContactCenterNewValidationCards
                amount={amount}
                agreementErrorMsg={agreementErrorMsg}
                agreementLabel={agreementLabel}
                contractName="visa-open"
                handleAgreementCheckboxChange={onHandleChangeCheckBox}
                isContractingProcess
                immStep={immStep}
                precontractualMailProductInfo={precontractualMailProductInfo}
                sendMailParams={sendMailParams}
                showIneAndRevolving={true}
                showRevolvingDocument={true}
                processEmail={processEmail}
                immHireCardOpenCredit={immCardChangePaymentMethod}
                onHandleChangeCheckBoxCC={onHandleChangeCheckBoxCC}
                ineNotCall={newCardsFF}
                newIntLoading={newIntLoading}
                newCardsFF={newCardsFF}
            />
        )

    }
    const legalConfirmationSection = buildLegalConfirmationSection();

    const buildSummary = () => {
        const immStepOne = immCardChangePaymentMethod.get('steps').get(0);
        const currentPaymentMethod = immStepOne.get('currentPaymentMethod');
        const methodSelectedQuota = immHirePaymentMethod.get('value');
        const tin = immPdfRevolvingPersistent.getIn(['paramsInne', 'tin'])
        const tae = immPdfRevolvingPersistent.getIn(['paramsInne', 'tae'])
        const installmenAmount = immPdfRevolvingPersistent.get('firstPaymentAmount')

        const paymentMethod = {
            [CARD_PAYMENT_METHOD_UNIQUE]: `${formatText('cardChangePaymentMethod-unique')}`,
            [CARD_PAYMENT_METHOD_FIXED]: `${formatText('cardChangePaymentMethod-fixed')}`,
            [CARD_PAYMENT_METHOD_VARIABLE]: `${formatText('cardChangePaymentMethod-variable')}`
        };

        const currentMethodText = paymentMethod[currentPaymentMethod];
        let methodSelectedText = paymentMethod[currentMethod];

        if (currentMethod !== CARD_PAYMENT_METHOD_UNIQUE) {
            methodSelectedText += ` ${methodSelectedQuota} ${currentMethod === CARD_PAYMENT_METHOD_FIXED ? formatText('currencies-EUR') : '%'}`;
        }
        return (
            <>
                <div className="card-change-payment-method-step-two__summary row">
                    <div className="col-xs-12 card-change-payment-method-step-two__subtitle">
                        <FormattedText value="cardChangePaymentMethod-revolvingMessageStep2" />
                    </div>
                    <div className="col-xs-6 print-label">
                        <div className="card-change-payment-method-step-two__summary-label">
                            <FormattedText value="cardChangePaymentMethod-currentPaymentMethod" />
                        </div>
                        <div className="card-change-payment-method-step-two__summary-label">
                            {currentMethodText}
                        </div>
                    </div>
                    <div className="col-xs-6">
                        <div className="card-change-payment-method-step-two__summary-label">
                            <FormattedText value="cardChangePaymentMethod-newPaymentMethod" />
                        </div>
                        <div className="card-change-payment-method-step-two__summary-label">
                            {methodSelectedText}
                        </div>
                    </div>
                </div>
                {currentMethod !== CARD_PAYMENT_METHOD_UNIQUE && (
                    <div className="card-change-payment-method-step-two__summary row">
                        <div className="col-xs-6 print-label">
                            <div className="card-change-payment-method-step-two__summary-label">
                                <FormattedText value="cardChangePaymentMethod-newInstallmenAmount" />
                            </div>
                            <div className="card-change-payment-method-step-two__summary-label">
                                {installmenAmount}
                            </div>
                        </div>

                        <div className="col-xs-6">
                            <div className="card-change-payment-method-step-two__summary-label">
                                <FormattedText value="cardChangePaymentMethod-interests" />
                            </div>
                            <div className="card-change-payment-method-step-two__summary-label">
                                <span>
                                    {formatText('hireCardSidebar-tin')}
                                    {" "}
                                    {tin}
                                </span>
                                {" "}
                                <span>
                                    <strong>
                                        {formatText('hireCardSidebar-tae')}
                                        {" "}
                                        {tae}
                                    </strong>
                                </span>
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    };

    return (
        <article className="card-change-payment-method-step-two">
            <header className="card-change-payment-method-step-two__header">
                <FormattedText
                    value={titleKey}
                    className="card-change-payment-method-step-two__title"
                />
            </header>
            {isForRevolvingProcess && buildSummary()}
            {__CONTACT_CENTER__ && !isPrintOfficeMode() &&
                <BlockInfo>
                    <p className="requiredReading">
                        <FormattedText value="cc_hireNewCreditCard-requiredReading" />
                    </p>
                    <FormattedText value={'cardChangePaymentMethod-blockSummaryInfoCC'} />

                </BlockInfo>
            }
            <div className="card-change-payment-method-step-two__consents-content">
                <OKConsents placementId={placementIdCard} />
            </div>
            {__CONTACT_CENTER__ && isPrintOfficeMode() &&
                <HireNewCreditCardPdf
                    immHireCardNameSelector={immHireCardNameSelector}
                    immHireCreditLimit={immHireCreditLimit}
                    immHirePaymentMethod={immHirePaymentMethod}
                    immShippingAddressList={immShippingAddressList}
                    hireNewCreditCard={immCardChangePaymentMethod}
                    setPrintOffice={setPrintOffice}


                />
            }
            {!__CONTACT_CENTER__ &&
                <HireNewCreditCardPdf
                    immHireCardNameSelector={immHireCardNameSelector}
                    immHireCreditLimit={immHireCreditLimit}
                    immHirePaymentMethod={immHirePaymentMethod}
                    immShippingAddressList={immShippingAddressList}
                    hireNewCreditCard={immCardChangePaymentMethod}
                    setPrintOffice={setPrintOffice}

                />
            }
            {__CONTACT_CENTER__ && !isPrintOfficeMode() &&
                <ContactCenterRender>
                    {legalConfirmationSection}
                </ContactCenterRender>
            }
            {__CONTACT_CENTER__ && !isPrintOfficeMode() &&
                <>
                    {agreeIneCheckbox &&
                        <GDPRSignaturePattern
                            operationType={CARD_PAYMENT_CHANGE_ID}
                            operationParams={[]}
                            newOperationProcessId={operationProcessId}
                            sendOnlyOperationProcessid={true}
                        />
                    }
                </>
            }
            {__CONTACT_CENTER__ && isPrintOfficeMode() && printOffice &&
                <GDPRSignaturePattern
                    operationType={CARD_PAYMENT_CHANGE_ID}
                    operationParams={[]}
                    newOperationProcessId={operationProcessId}
                    sendOnlyOperationProcessid={true}
                    isEasyLoanTypeAB={isPrintOfficeMode() && true}

                />
            }
            {!__CONTACT_CENTER__ &&
                <GDPRSignaturePattern
                    operationType={CARD_PAYMENT_CHANGE_ID}
                    operationParams={[]}
                    newOperationProcessId={operationProcessId}
                    sendOnlyOperationProcessid={true}
                    isOverDraft={true}
                />
            }
        </article>

    );
};

